import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Card from '@material-ui/core/Card';
import DefaultCardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { Link as ReactRouterLink } from 'react-router-dom';
import _ from 'lodash';

import Auth from '../Auth';
import { API_BASE_URL } from '../../styles/constant';
import { getGDGroups } from '../../services/groupDiscussionServices';
import CitySelector from '../CitySelector';
import PanelSelector from '../PanelSelector';
import ModalForm from '../ModalForm';
import Loader from '../Loader';

const colors = ['#651FFF', '#2979FF', '#9C27B0', '#03A9F4', '#E91E63', '#8BC34A'];

class GroupDiscussion extends React.Component {
  static propTypes = {
    authenticatedUserInfo: PropTypes.object.isRequired,
  };

  state = {
    gdGroups: null,
    selectedCity: null,
    selectedPanel: null,
    activeTabIndex: 0,
  };

  unsubscribe = null;

  componentDidMount() {
    this.loadGDGroups();
  }

  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  loadGDGroups = () => {
    const {
      authenticatedUserInfo: { type },
    } = this.props;

    if (type === 'ADMIN') {
      this.unsubscribe = getGDGroups((gdGroups) => {
        this.setState({ gdGroups });
      });
    }
  };

  renderGroups = () => {
    const {
      gdGroups, selectedCity, selectedPanel, activeTabIndex,
    } = this.state;

    if (!gdGroups) {
      return <Loader />;
    }

    let filteredGroups = gdGroups;
    if (selectedCity && selectedCity !== 'OVERALL') {
      filteredGroups = _.filter(filteredGroups, { jypCity: selectedCity });
    }
    if (selectedPanel && selectedPanel !== 'OVERALL') {
      filteredGroups = _.filter(filteredGroups, { panel: selectedPanel });
    }

    if (activeTabIndex === 0) {
      filteredGroups = _.filter(filteredGroups, { completed: false });
    } else if (activeTabIndex === 1) {
      filteredGroups = _.filter(filteredGroups, { completed: true });
    }

    if (filteredGroups.length > 0) {
      return (
        <CardsContainer>
          {filteredGroups.map((group, index) => (
            <GDCard key={group.id} background={colors[index % colors.length]}>
              <CardContent>
                <Typography variant="body1">Group ID</Typography>
                <Typography variant="body2" style={{ marginBottom: 16 }}>
                  {group.groupDiscussionID}
                </Typography>

                <Typography variant="subheading">Number of Candidates</Typography>
                <Typography variant="display1" style={{ marginBottom: 16 }}>
                  {group.candidates.length}
                </Typography>

                <Typography variant="subheading">City</Typography>
                <Typography variant="display1" style={{ marginBottom: 16 }}>
                  {group.jypCity}
                </Typography>

                {group.panelist && (
                  <ContentInfoContainer>
                    <div>
                      <Typography variant="subheading">Panelist</Typography>
                      <Typography variant="body1">{group.panelist.name}</Typography>
                    </div>
                    <Divider />
                    <div>
                      <Typography variant="subheading">Panel</Typography>
                      <Typography variant="body1">{group.panel}</Typography>
                    </div>
                  </ContentInfoContainer>
                )}
              </CardContent>
              <DefaultCardActions>
                <Button
                  variant="raised"
                  color="primary"
                  component={ReactRouterLink}
                  to={`/group-discussion/${group.id}`}
                  target="_blank"
                >
                  View Group
                </Button>
              </DefaultCardActions>
            </GDCard>
          ))}
        </CardsContainer>
      );
    }
    return <Typography variant="body2">No Groups Present</Typography>;
  };

  render() {
    if (!this.props.authenticatedUserInfo) {
      return null;
    }

    return (
      <Card>
        <CardActions>
          <Typography variant="headline">GD Groups</Typography>
          <Spacer />
          {this.props.authenticatedUserInfo.type === 'ADMIN' && [
            <PanelSelector
              key="panel-selector"
              onChange={(panel) => {
                this.setState({ selectedPanel: panel });
              }}
              addOverall
            />,
            <CitySelector
              key="city-selector"
              onChange={(city) => {
                this.setState({ selectedCity: city });
              }}
              addOverall
            />,
          ]}
          <ModalForm
            trigger={(
              <Button variant="contained" color="primary">
                CREATE GD GROUPS
              </Button>
)}
            apiEndpoint={`${API_BASE_URL}/groupDiscussion/createGroups/?id=${
              this.props.authenticatedUserInfo.id
            }`}
          />
        </CardActions>
        <CardContent>
          <TabsContainer>
            <Tabs
              value={this.state.activeTabIndex}
              onChange={(event, value) => {
                this.setState({ activeTabIndex: value });
              }}
            >
              <Tab label="Upcoming GD" />
              <Tab label="Completed GD" />
              <Tab label="All GD" />
            </Tabs>
          </TabsContainer>
          {this.renderGroups()}
        </CardContent>
      </Card>
    );
  }
}

export default () => <Auth>{({ authState }) => <GroupDiscussion {...authState} />}</Auth>;

const CardActions = styled(DefaultCardActions)`
  && {
    justify-content: flex-end;

    & > * + * {
      margin-left: 16px;
    }
  }
`;

const Spacer = styled.div`
  display: flex;
  flex: 1;
`;

const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 16px;
`;

const ContentInfoContainer = styled.div`
  display: flex;
  justify-content: space-between;

  & > * + * {
    margin-left: 16px;
  }
`;

const Divider = styled.div`
  width: 1px;
  background-color: ${props => props.theme.palette.primary.contrastText};
`;

const TabsContainer = styled.div`
  margin-bottom: 16px;
  && {
    background: ${props => props.theme.palette.primary.main};
  }

  & * {
    color: ${props => props.theme.palette.primary.contrastText} !important;
  }
`;

const GDCard = styled(Card)`
  && {
    background-color: ${props => props.background};
    & * {
      color: ${props => props.theme.palette.primary.contrastText} !important;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/GroupDiscussion/GroupDiscussion.js